import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import MaintenanceCreateUpdate, {
  MaintenanceCreateUpdateHandle,
  MaintenanceCreateUpdateProps,
} from "./MaintenanceCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: MaintenanceCreateUpdateProps;
}

export default function MaintenanceCreateUpdateModal({ createUpdateProps, ...modalProps }: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.maintenanceId });
  const formWrapperRef = useRef<MaintenanceCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} maintenance
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <MaintenanceCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
